import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column p-jc-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_page = _resolveComponent("home-page")!
  const _component_login_page = _resolveComponent("login-page")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoggedIn && _ctx.tokenStillValid)
        ? (_openBlock(), _createBlock(_component_home_page, {
            key: 0,
            class: "p-mb-2"
          }))
        : (_openBlock(), _createBlock(_component_login_page, {
            key: 1,
            class: "p-mb-2"
          }))
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_Footer, { class: "p-mb-2" })
    ])
  ], 64))
}